module.exports = __webpack_public_path__ + "img/150-5.e60e41f0.jpg";